<script>
  import {getContext, createEventDispatcher} from 'svelte';
  import DrawerModal from '@/widgets/DrawerModal.svelte';
  import NewDeviceCodeForm from '../componets/NewDeviceCodeForm.svelte';
  import lang from '../LoginPage.lang';

  export let onSubmit;
  export let isNeed2FA = false;
  export let email = '';

  const dispatch = createEventDispatcher();
  const LG = getContext('LG');

  function handleClickClose() {
    dispatch('close');
  }
</script>

<style>
  .wrap {
    margin-top: 40px;
  }
  .arrow {
    transform: rotate(-180deg);
  }
</style>

<DrawerModal visible>
  <div class="wrap">
    <div class="df aic cp" on:click={handleClickClose}>
      <div class="arrow">
        <i class="iconfont BLUE">&#xe60b;</i>
      </div>
      <span class="BLUE ml10">{LG(lang.Back)}</span>
    </div>
    <NewDeviceCodeForm isDrawer={true} {onSubmit} {email} {isNeed2FA} />
  </div>
</DrawerModal>
